// 广告独立接口请求枚举
export enum AdFeedStyle {
  AD_FEED_STYLE_NONE = 0, // 默认样式
  AD_FEED_STYLE_NORMAL = 1, // 普通样式
  AD_FEED_STYLE_LABEL = 2, // 信息流卡-标签样式 (短剧/小游戏)
  AD_FEED_STYLE_CARD_LARGE = 3, // 大卡样式 (搜索页)
  AD_FEED_STYLE_CARD_SMALL = 4, // 小卡样式 (搜索页)
  // 按钮样式
  AD_FEED_STYLE_LABELS = 6,   // 默认卡片样式 (标签#6)
  AD_FEED_STYLE_BUTTON_GRADIENT = 7,   // 按钮_渐变(#1)
  AD_FEED_STYLE_BUTTON_GAME1 = 8,   // 按钮_小游戏(#2)
  AD_FEED_STYLE_BUTTON_GAME2 = 9,   // 按钮_页游(#3)
  AD_FEED_STYLE_QRCODE_ANIMATION = 10,  // 扫码_动效(#4)
}

export enum AdReqType {
  AD_REQ_TYPE_PLAYER_SWITCH = 0,  // 短剧播放详情页切换
  AD_REQ_TYPE_REC_LIST      = 1,  // 短剧相关推荐请求
  AD_REQ_TYPE_SEARCH_PAGE   = 2,  // 搜索页广告
  AD_REQ_TYPE_GAME_QRCODE   = 3,  // 小游戏扫码
  AD_REQ_TYPE_GAME_REC_LIST = 4,  // 小游戏推荐列表
}

// CGI 上报类型
export enum CGIReportType {
  REPORT_TYPE_UNKNOWN = 0, // 默认
  REPORT_TYPE_ORIGIN_EXPOSURE = 1, // 原始曝光上报
  REPORT_TYPE_EFFECT_EXPOSURE = 2, // 有效曝光上报
  REPORT_TYPE_THIRD_CLICK = 3, // 第三方点击上报
  REPORT_TYPE_AD_PLAY = 4, // 播放上报
}

// 落地页打开类型
export enum LandingPageShowType {
  LANDING_PAGE_SHOW_TYPE_UNKNOWN   = 0,  // 未知
  LANDING_PAGE_SHOW_TYPE_SPLIT     = 1,  // 拼接页拉起
  LANDING_PAGE_SHOW_TYPE_HALF_PAGE = 2,  // 半屏打开落地页
}

// 广告场景
export enum AdScene {
  CHANNEL_PAGE          = 0,   // 默认频道页
  IMMERSIVE             = 5,   // 沉浸式场景
  NET_MOVIE             = 12,  // 网络大电影
  DETAIL_SKIT_PLAYER_AD = 13,  // 短剧底层页-播放器广告
  DETAIL_SKIT_REC_LIST  = 14,  // 短剧底层页-推荐列表
  CHANNEL_GAME_QRCODE   = 17,  // 小游戏扫码
  CHANNEL_GAME_REC_LIST = 18,  // 小游戏推荐列表
}

export enum NetworkConnectionType {
  UNKNOWN = 0,
  WIFI = 1,
  NET_2G = 2,
  NET_3G = 3,
  NET_4G = 4,
  NET_4G_NOT_LIMIT = 5,
  NET_4G_LIMIT = 6,
  NET_5G = 7,
  ETHERNET = 8,
  NO_NETWORK = 50
};

// 标签分类
export enum LabelType {
  LABEL_TYPE_UNKONWN = 0,    // 未使用
  LABEL_TYPE_POPULARITY = 1, // 人气榜 (榜单标签)
  LABEL_TYPE_PLAY = 2,       // 畅玩榜
  LABEL_TYPE_ACTIVE = 3,     // 活跃 (行为标签)
  LABEL_TYPE_COLLECT = 4,    // 收藏 (行为标签)
  LABEL_TYPE_SHARE = 5,      // 分享 (行为标签)
  LABEL_TYPE_BESTSELLER = 6, // 畅销榜
  LABEL_TYPE_NEWGAMES = 7,   // 新游榜
  LABEL_TYPE_CATEGORY_2 = 8, // 二级分类标签 (品类标签)
  LABEL_TYPE_CATEGORY_3 = 9  // 三级分类标签 (品类标签)
}

// 小游戏标签分类
export enum MGLabelGroup {
  LABEL_GROUP_UNKONWN = 0,
  LABEL_GROUP_RANK = 1,     // 榜单标签
  LABEL_GROUP_ACTION = 2,   // 行为标签
  LABEL_GROUP_CATEGORY = 3  // 品类标签
}

// 交互方式
export enum AdInteractiveMode {
  IMODE_UNKNOWN     = 0,  // 未知
  IMODE_CLICK       = 1,  // 点击
  IMODE_SCAN_QRCODE = 7,  // 扫二维码
}